import { Injectable } from '@angular/core';
import { CustomXmlPart } from '../interfaces/customxmlpart';
import { Dom } from './dom';

@Injectable({ providedIn: 'root' })
export abstract class AbstractPartService {
  async getDOM(part: CustomXmlPart): Promise<Dom> {
    const rootNodeXml = await part.getXml();
    return new Dom(rootNodeXml);
  }
}
